import React, { Suspense } from 'react';

const DelayedChannelSelectionStep =
  React.lazy(() => import(/* webpackChunkName: "channel-selection-step.async" */ './channel-selection-step')
    .then(({ ChannelSelectionStepWithI18n }) => ({ default: ChannelSelectionStepWithI18n })));

export const DelayedChannelSelectionStepWithI18n = () => (
  <Suspense fallback={null}>
    <DelayedChannelSelectionStep />
  </Suspense>
);
